import AssignmentScheduleViewer from './AssignmentScheduleViewer';

export default AssignmentScheduleViewer;
